/* istanbul ignore file */

export const onetrustStyles = `
/* ─── Global variables ───────────────────────────────────────────────────── */

#onetrust-consent-sdk {
  --font-family:
    SweetSansText-Regular, SweetSansText, system-ui, -apple-system, Segoe UI,
    Roboto, Helvetica Neue, Arial, Noto Sans, Liberation Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  --focus-outline-color: #898989;
  --color: #0e150e;
  --background-color: #ffffff;

  --close-button-bg-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNSA1LjVMMTguNSAxOC41IiBzdHJva2U9IiMwRTE1MEUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4LjUgNS41TDUuNSAxOC41IiBzdHJva2U9IiMwRTE1MEUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
  --close-button-bg-size: 24px;

  --banner-font-size: 12px;
  --banner-font-weight: 400;
  --banner-line-height: 1.334;
  --banner-letter-spacing: 0.2px;
  --banner-box-shadow: 3px 3px 32px -10px rgba(14, 21, 14, 0.4);
  --banner-position-left: 0;
  --banner-padding: 24px;
  --banner-margin: 8px;
  --banner-close-button-size: 40px;

  --preferences-center-border-radius: 0;
}

@media screen and (min-width: 576px) {
  #onetrust-consent-sdk {
    --banner-position-left: auto;
    --banner-width: 260px;
    --banner-margin: 16px;

    --preferences-center-border-radius: 24px;
  }
}

#onetrust-consent-sdk,
#onetrust-consent-sdk * {
  box-sizing: border-box;
}

/* ─── Resets ─────────────────────────────────────────────────────────────── */

#onetrust-group-container {
  width: 100% !important;
  margin-bottom: 24px !important;
}

#onetrust-policy {
  width: 100% !important;
  margin: 0 !important;
}

#onetrust-policy-text {
  font-family: var(--font-family) !important;
  font-size: var(--banner-font-size) !important;
  font-weight: var(--banner-font-weight) !important;
  line-height: var(--banner-line-height) !important;
  letter-spacing: var(--banner-letter-spacing) !important;
  color: var(--color) !important;
}

#onetrust-policy-text a {
  color: var(--color) !important;
  font-weight: 400 !important;
}

#onetrust-button-group-parent {
  width: 100% !important;
  position: static !important;
  padding: 0 !important;
  transform: unset !important;
}

#onetrust-button-group {
  display: flex !important;
  flex-direction: column;
  gap: 8px;
}

#onetrust-consent-sdk a:focus,
#onetrust-consent-sdk button:focus,
#onetrust-consent-sdk input:focus {
  outline: unset !important;
}

#onetrust-consent-sdk input:focus + label {
  outline: unset !important;
}

#onetrust-consent-sdk a:focus-visible,
#onetrust-consent-sdk button:focus-visible,
#onetrust-consent-sdk input:focus-visible,
#onetrust-consent-sdk input:focus-visible + label {
  outline: 1px solid var(--focus-outline-color) !important;
  outline-offset: 2px !important;
}

#ot-pc-title,
#ot-category-title,
#onetrust-pc-sdk button:not(.save-preference-btn-handler),
.ot-cat-header,
.ot-always-active {
  font-family: SweetSansText-Bold, var(--font-family) !important;
}

/* ─── Buttons ────────────────────────────────────────────────────────────── */

#onetrust-button-group button,
.save-preference-btn-handler,
#accept-recommended-btn-handler {
  --bg-color: #fff;
  --bg-color-hover: #00473c;
  --color: #0e150e;
  --color-hover: #f4f3e7;

  margin: 0 !important;
  flex: 1 !important;
  order: 0 !important;
  min-height: 40px !important;
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 1.286 !important;
  text-align: center !important;
  border-radius: 20px !important;
  border: 1px solid #00473c !important;
  padding: 8px 16px !important;
  cursor: pointer !important;
  text-decoration: none !important;
  text-overflow: ellipsis !important;
  transition:
    background 240ms ease-in-out,
    color 240ms ease-in-out,
    opacity 240ms ease-in-out !important;
  background: var(--bg-color) !important;
  color: var(--color) !important;
  letter-spacing: unset !important;
  text-transform: unset !important;
  position: relative !important;
  opacity: 1 !important;
}

#onetrust-button-group button:hover,
.save-preference-btn-handler:hover,
#accept-recommended-btn-handler:hover {
  background: var(--bg-color-hover) !important;
  color: var(--color-hover) !important;
}

.save-preference-btn-handler,
#accept-recommended-btn-handler {
  --bg-color: #00473c;
  --bg-color-hover: #2d6b52;
  --color: #f4f3e7;
  --color-hover: var(--color);
}

/* ─── Banner ─────────────────────────────────────────────────────────────── */

#onetrust-banner-sdk {
  background-color: var(--background-color) !important;
  width: var(--banner-width) !important;
  left: var(--banner-position-left) !important;
  border-radius: 24px;
  padding: var(--banner-padding);
  margin: var(--banner-margin);
  overflow-x: unset !important;
  overflow-y: unset !important;
  box-shadow: var(--banner-box-shadow);
  box-sizing: border-box !important;
}

/* Hide default focus...*/
#onetrust-banner-sdk:focus {
  outline: none !important;
}

/* ...and replace it with a more modern approach*/
#onetrust-banner-sdk:focus-visible {
  outline: 2px solid var(--focus-outline-color);
  outline-offset: 6px;
}

.ot-sdk-container {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* ─── Banner Close Button ────────────────────────────────────────────────── */

#onetrust-close-btn-container {
  display: flex !important;
  position: absolute !important;
  top: calc((var(--banner-close-button-size) + 8px) * -1) !important;
  right: 0 !important;
  transform: unset !important;
}

#onetrust-close-btn-container .onetrust-close-btn-handler {
  position: static !important;
  width: var(--banner-close-button-size) !important;
  height: var(--banner-close-button-size) !important;
  border-radius: 100%;
  background-color: var(--background-color) !important;
  background-image: var(--close-button-bg-image) !important;
  background-size: var(--close-button-bg-size) !important;
  background-repeat: no-repeat;
  background-position: center center;
  box-shadow: var(--banner-box-shadow) !important;
  transition: opacity 0.24s ease-in-out !important;
}

/* ─── Preferences Center ─────────────────────────────────────────────────── */

#onetrust-pc-sdk {
  font-family: var(--font-family) !important;
  border-radius: var(--preferences-center-border-radius) !important;
}

#ot-pc-content {
  width: 100% !important;
  margin: 0 !important;
  padding: 16px 30px !important;
  box-sizing: border-box !important;
}

#ot-pc-content:focus {
  outline: unset !important;
}

.ot-pc-footer .ot-btn-container {
  padding: 16px !important;
}

.save-preference-btn-handler {
  margin: unset !important;
}

#close-pc-btn-handler {
  top: 7px !important;
  right: 16px !important;
  background-image: var(--close-button-bg-image) !important;
  background-size: var(--close-button-bg-size) !important;
  background-repeat: no-repeat;
  background-position: center center;
  transition: opacity 0.24s ease-in-out !important;
  margin: unset !important;
}

#close-pc-btn-handler:hover {
  opacity: 0.5 !important;
}
`;
